import { MCP_SERVER_URL, AgentConnectionsList, isGeminiConnection } from '../../settings-connections';
import { useConnectClaude } from '../../../../lib/agent-connections';
import { buildClaudeSkill } from '../../../../lib/claude-skill';
import { useProductName } from '../../../../lib/use-brand';
import { useTranslation } from '../../../../lib/i18n';
import { ChatGptGlyph, ClaudeCodeGlyph, ClaudeGlyph } from '../BrandGlyphs';
import { matchesChannelTitle, type AiCoderTitleKey } from '../channel-search';
import { ConnectInstructionCard } from './ConnectInstructionCard';
import styles from './mobile.module.css';

/**
 * The AI-coder channel, mobile (Figma 13131-79232): three connect cards — Claude Code (Copy mints an
 * act-as-me token and copies the ready-to-paste skill), then Claude web & desktop and ChatGPT (each
 * copies the MCP endpoint). The already-connected coder agents list below (hidden when empty) keeps
 * the ability to revoke. The token mint and the copied values are the shared ones — only the card
 * presentation is mobile.
 */
export function AiCodersMobile({ query = '' }: { query?: string } = {}) {
  const { t } = useTranslation();
  const productName = useProductName();
  const connect = useConnectClaude();
  // A coder-name query narrows to the matching card(s) — the section is already visible because one of
  // these titles matched. Same keys drive both decisions, as on native.
  const show = (key: AiCoderTitleKey) => matchesChannelTitle(t(key), query);

  return (
    <div className={styles.channelBody}>
      {show('connections.claude.title') && (
        <ConnectInstructionCard
          icon={<ClaudeCodeGlyph size={18} />}
          title={t('connections.claude.title')}
          description={t('connections.claude.subtitle')}
          copyBiName="copy-claude-instructions"
          getValue={async () => {
            const { token } = await connect.mutateAsync(undefined);
            return buildClaudeSkill(token);
          }}
        />
      )}
      {show('connections.connect.claudeWeb.title') && (
        <ConnectInstructionCard
          icon={<ClaudeGlyph size={18} />}
          title={t('connections.connect.claudeWeb.title')}
          description={t('connections.connect.claudeWeb.instructions', { productName })}
          getValue={() => MCP_SERVER_URL}
          copyBiName="copy-claude-web-url"
        />
      )}
      {show('connections.connect.chatgpt.title') && (
        <ConnectInstructionCard
          icon={<ChatGptGlyph size={18} />}
          title={t('connections.connect.chatgpt.title')}
          description={t('connections.connect.chatgpt.instructions')}
          getValue={() => MCP_SERVER_URL}
          copyBiName="copy-chatgpt-url"
        />
      )}
      <AgentConnectionsList filter={(c) => !isGeminiConnection(c)} />
    </div>
  );
}
